import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="bg-wine-dark py-16 sm:py-24" data-id="element-263" data-mp="36y3qtsjv9yer">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-264" data-mp="322y6gy644rss">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,24rem)_minmax(0,1fr)] lg:gap-20" data-id="element-265" data-mp="2y2eahxx9zu88">
          <div data-id="element-266" data-mp="2t4mil3wms841">
            <Eyebrow tone="rose" data-id="element-267" data-mp="2t55rjv4azm5x">The reality of jazz teaching</Eyebrow>
            <h2 id="problems-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-5xl" data-id="element-268" data-mp="2o4qdt2g40cnf">
              If you teach jazz guitar, <span className="text-amber" data-id="element-269" data-mp="2f4uyclfitvhl">you already know this list.</span>
            </h2>
            <p className="mt-6 border-l-2 border-rose pl-5 font-serif text-xl italic leading-snug text-cream-soft" data-id="element-270" data-mp="hetmkbvmyqyh">
              How much longer are you willing to improvise?
            </p>
          </div>

          <ul className="divide-y divide-wine/60" data-id="element-271" data-mp="34r4rw4oimro2">
            {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-5 first:pt-0 last:pb-0" data-id="element-272" data-mp="39py31qgby6l2">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose-deep" data-id="element-273" data-mp="2vq6n3k696g4f">
                  <XIcon className="h-3.5 w-3.5 text-rose" aria-hidden="true" data-id="element-274" data-mp="2zr8nw5ftj08i" />
                </span>
                <span className="text-base leading-relaxed text-cream-soft" data-id="element-275" data-mp="3ngunuv40ljhk">{problem}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}